import { useParams } from "react-router-dom";
import SEO from "@/components/SEO";
import { Reveal, PageBand, CTABand, ConcernTile } from "@/components/Shared";
import { CONCERN_FAMILIES, concernsByFamily } from "@/data/concerns";
import { PAGE_HEROES, CONCERN_HEROES } from "@/data/photos";
import NotFound from "@/pages/NotFound";

const ConcernFamily = () => {
  const { family } = useParams();
  const fam = CONCERN_FAMILIES.find((f) => f.slug === family);
  if (!fam) return <NotFound />;
  const concerns = concernsByFamily(family);

  return (
    <>
      <SEO title={`${fam.title} Concerns | Lumière Aesthetics, Cottesloe`} description={`${fam.blurb} Honest answers from doctor-run practitioners in Cottesloe, WA.`} />
      <PageBand eyebrow="Concerns" title={fam.title} standfirst={fam.blurb} image={CONCERN_HEROES[fam.slug] || PAGE_HEROES.default} />

      <section className="bg-warm-white" data-testid="family-grid">
        <div className="shell py-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {concerns.map((c, i) => (
              <ConcernTile key={c.slug} concern={c} index={i} />
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </>
  );
};

export default ConcernFamily;
